import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 24px;
  width: 24px;
`
export const PosIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.9004 7.40002H15.1004V6.70002C15.1004 6.30002 14.7004 5.90002 14.3004 5.90002H6.70039C6.30039 5.90002 5.90039 6.30002 5.90039 6.70002V17.3C5.90039 17.7 6.30039 18.1 6.70039 18.1H14.2004C14.6004 18.1 15.0004 17.7 15.0004 17.3V14.5H16.8004C17.5004 14.5 18.0004 13.9 18.0004 13.3V8.60002C18.1004 7.90002 17.5004 7.40002 16.9004 7.40002ZM8.90039 16.2H7.80039V15.1H8.90039V16.2ZM8.90039 14.1H7.80039V13H8.90039V14.1ZM8.90039 12H7.80039V10.9H8.90039V12ZM11.0004 16.2H9.90039V15.1H11.0004V16.2ZM11.0004 14.1H9.90039V13H11.0004V14.1ZM11.0004 12H9.90039V10.9H11.0004V12ZM13.1004 16.3H12.0004V13H13.1004V16.3ZM13.1004 12H12.0004V10.9H13.1004V12ZM13.1004 10H7.80039V7.90002H13.1004V10ZM17.1004 13.3C17.1004 13.4 17.0004 13.5 16.9004 13.5H15.1004V8.30002H16.9004C17.0004 8.30002 17.1004 8.40002 17.1004 8.50002V13.3Z" />
    </Svg>
  )
}
